import { createContext, useContext } from 'react';

import type { PackageUtilizationExpectationListItem } from 'types';

type ModalType = 'register' | 'list' | 'edit' | 'delete' | null;

interface ModalState {
  type: ModalType;
  packageExpectation?: PackageUtilizationExpectationListItem | null;
  opened: boolean;
}

interface ModalContextValue {
  modal: ModalState;
  openModal: (type: ModalType, data?: PackageUtilizationExpectationListItem | null) => void;
  closeModal: () => void;
}

const ModalContext = createContext<ModalContextValue | null>(null);

const useModal = (): ModalContextValue => {
  const ctx = useContext(ModalContext);
  if (!ctx) throw new Error('useModal must be used within ModalProvider');
  return ctx;
};

export default ModalContext;
export type { ModalType, ModalState, ModalContextValue };
export { useModal };
